import { db, firestorage } from "../Config";
import { COrden } from "../../../Entidades/Orden";
import firebase from "firebase/app";
// función asincrona de fetch ordenes
export const fetchOrdenesRx = () => {
  return new Promise((resolve, reject) => {
    let ordenesRef = db.collectionGroup("ordenesRx");
    let ordenes = [];
    ordenesRef
      .where("estado", "in", ["SOLICITADO"])
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          ordenes.push({
            id: doc.id, // Use doc.id from query
            estado: doc.data().estado,
            fecEnv: doc.data().fecEnv.toDate(),
            fecTer: doc.data().fecTer,
            centroRxId: doc.data().centroRxId,
            centroRxNombre: doc.data().centroRxNombre,
            pacienteId: doc.data().pacienteId,
            paciente: doc.data().paciente,
            empresaId: doc.data().empresaId,
            items: doc.data().items,
            empresa: doc.data().empresa,
            comentarios: doc.data().comentarios,
          });
        });
        resolve(ordenes);
      })
      .catch((err) => reject(err));
  });
};

export const fetchOrdenesRxEmpresa = (empresaId) => {
  return new Promise((resolve, reject) => {
    let ordenesRef = db.collectionGroup("ordenesRx");
    let ordenes = [];
    ordenesRef
      .where("empresaId", "==", Number(empresaId))
      .where("estado", "in", ["PENDIENTE", "SOLICITADO"])
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          ordenes.push({
            id: doc.id,
            estado: doc.data().estado,
            fecEnv: doc.data().fecEnv,
            fecTer: doc.data().fecTer,
            centroRxId: doc.data().centroRxId,
            centroRxNombre: doc.data().centroRxNombre,
            pacienteId: doc.data().pacienteId,
            paciente: doc.data().paciente,
            empresaId: doc.data().empresaId,
            items: doc.data().items,
            empresa: doc.data().empresa,
            comentarios: doc.data().comentarios,
          });
        });
        resolve(ordenes);
      })
      .catch((err) => reject(err));
  });
};

export const fetchOrdenesRxPaciente = (pacienteId, empresaId) => {
  return new Promise((resolve, reject) => {
    let ordenesRef;
    if (empresaId) {
        ordenesRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("ordenesRx");
    } else {
        // Fallback or explicit warning
        console.warn("empresaId missing in fetchOrdenesRxPaciente, trying legacy/collectionGroup lookup might fail if not careful");
        // We can't easily guess empresaId here without query.
        // Assuming we update callers to pass it.
        // For safety, if no empresaId, maybe try collectionGroup? But that's inefficient for single patient.
        // Let's enforce empresaId.
        reject(new Error("empresaId required for fetchOrdenesRxPaciente"));
        return;
    }
    
    let ordenes = [];
    ordenesRef
      .where("pacienteId", "==", pacienteId)
      .where("estado", "in", ["PENDIENTE", "ENVIADO"])
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          ordenes.push({
            id: doc.id,
            estado: doc.data().estado,
            fecEnv: doc.data().fecEnv.toDate(),
            fecTer: doc.data().fecTer,
            centroRxId: doc.data().centroRxId,
            centroRxNombre: doc.data().centroRxNombre,
            paciente: doc.data().paciente,
            pacienteId: doc.data().pacienteId,
            empresaId: doc.data().empresaId,
            items: doc.data().items,
            empresa: doc.data().empresa,
            comentarios: doc.data().comentarios,
          });
        });
        resolve(ordenes);
      })
      .catch((err) => reject(err));
  });
};

export const getOrden = (ordenId, empresaId, pacienteId) => {
  let orden;
  // This function seems to be void? It fetches but returns nothing and handles success with empty catch?
  // It seems unused or poorly implemented. I will update it just in case.
  let ordenRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("ordenesRx").doc(ordenId);
  ordenRef
    .get()
    .then((doc) => {
      if (doc.exists) {
        orden = {
          id: doc.id,
          estado: doc.data().estado,
          fecEnv: doc.data().fecEnv,
          fecTer: doc.data().fecTer,
          centroRxId: doc.data().centroRxId,
          centroRxNombre: doc.data().centroRxNombre,
          pacienteId: doc.data().pacienteId,
          paciente: doc.data().paciente,
          empresaId: doc.data().empresaId,
          items: doc.data().items,
          empresa: doc.data().empresa,
          comentarios: doc.data().comentarios,
        };
      } else {
        orden = new COrden();
      }
    })
    .catch((err) => {});
};

var ordenConverter = {
  toFirestore: function (orden) {
    return {
      id: orden.id,
      estado: orden.estado,
      fecEnv: orden.fecEnv,
      fecTer: orden.fecTer,
      centroRxId: orden.labId,
      centroRxNombre: orden.labNombre,
      pacienteId: orden.pacienteId,
      paciente: orden.paciente,
      prestacionNombre: orden.prestacionNombre,
      estFin: orden.estFin,
      numCor: orden.numCor,
      empresa: orden.empresa,
    };
  },
  fromFirestore: function (snapshot, options) {
    const data = snapshot.data(options);
    return {
      id: data().id,
      estado: data().estado,
      fecEnv: data().fecEnv.toDate(),
      fecTer: data().fecTer,
      centroRxId: data().centroRxId,
      centroRxNombre: data().centroRxNombre,
      pacienteId: data().pacienteId,
      paciente: data().paciente,
      empresaId: data().empresaId,
      items: data().items,
      empresa: data().empresa,
      comentarios: data().comentarios,
    };
  },
  toDate(fecha) {
    if (typeof fecha === "string") return new Date(fecha);
  },
  toCadena(fecha) {
    if (typeof fecha === "object") {
      const a = fecha.getFullYear();
      const m = (fecha.getMonth() + 1).toString().padStart(2, "0");
      const d = fecha.getDate().toString().padStart(2, "0");
      return `${a}-${m}-${d}`;
    }
  },
};
